'use client';

import dynamic from 'next/dynamic';
import { useEffect } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import useUpsellContent from '@alltrails/upsell/hooks/useUpsellContent';

const PostAuthUpsellModal = dynamic(() => import('@alltrails/upsell/components/GenericPostAuthUpsell/PostAuthUpsellModal'), {
  ssr: false
});

/*
  AppleRedirectUpsell displays the post-auth Plus upsell to free (base) users who authenticated with Apple.
  For Apple auth, the user is taken to a separate page, then redirected back to our site.
  When a user returns, the apple_oauth param is included in search params.
 */

const AppleRedirectUpsell = () => {
  const { isOpen, serverUpsellContent, setIsOpen } = useUpsellContent('Complete Authentication', { delayOpen: true });
  const user = useUser();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('apple_oauth') && user?.subscriptionTier === 'base') {
      setIsOpen(true);
    }
  }, [setIsOpen, user]);

  return (
    <>
      {isOpen && (
        <PostAuthUpsellModal
          isOpen={isOpen}
          onCloseRequest={() => setIsOpen(false)}
          serverUpsellContent={serverUpsellContent}
          upsellTrigger="Complete Authentication"
        />
      )}
    </>
  );
};

export default AppleRedirectUpsell;
